/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedWordpressArticlesWrapper_viewer = {
    readonly isWordpressArticlesEnabled: boolean | null;
    readonly " $refType": "SbSharedWordpressArticlesWrapper_viewer";
};
export type SbSharedWordpressArticlesWrapper_viewer$data = SbSharedWordpressArticlesWrapper_viewer;
export type SbSharedWordpressArticlesWrapper_viewer$key = {
    readonly " $data"?: SbSharedWordpressArticlesWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedWordpressArticlesWrapper_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedWordpressArticlesWrapper_viewer",
  "selections": [
    {
      "alias": "isWordpressArticlesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "wordpressArticles"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"wordpressArticles\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '6eda2aff6f98e5cabc856bdec636e0aa';
export default node;
